@if (tenant() === null) {
  <div class="hc-app-splash">
    <div class="hc-app-splash-inner">
      <img class="hc-app-splash-logo" alt="Hypecast" src="assets/logos/HYPECASTdefault.svg" />
      <div class="hc-app-splash-bar">
        <div class="hc-app-splash-bar-fill"></div>
      </div>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
